import { useState, useEffect, useRef, useContext } from 'react'
import { collapsePanelContext } from '../components'

// Helper hook, that should not be used directly now.
// Only for the needs of useCollapseOpened.
export function useOpened(defaultOpened: boolean, open: boolean, state: string | null) {
  const [opened, setOpened] = useState(state !== null ? open : defaultOpened)

  useEffect(() => {
    if (state !== null) {
      setOpened(open)
    }
  }, [state, open])

  return opened
}

// Hook to determine if collapse is opened using
// multiple collapses control panel.
export function useCollapseOpened(defaultOpened: boolean, collapseIdx: number) {
  const collapsePanel = useContext(collapsePanelContext)
  const collapseState = collapsePanel.getCollapsesState()
  const { isOpen, uniqueIdx } = collapsePanel.getCollapseBlockState(collapseIdx)
  const open = useOpened(defaultOpened, isOpen, collapseState)

  return { open, uniqueIdx }
}
